<template>
  <div id="main">
    <div id="manu">
      <navigation />
    </div>
    <div id="contentBox">
      <div class="registervideoContainer"></div>
      <div class="w">
        <div class="shousuo">
          <input
            type="text"
            class="input__search"
            v-model="keywords"
            @keydown.enter="search"
            @keyup="getData($event)"
            @focus="isShow = true"
            @blur="handleBlur"
            placeholder="搜索回收站..."
          >
          <button @click="search">
            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" height="20px" width="20px">
              <path
                d="M4 9a5 5 0 1110 0A5 5 0 014 9zm5-7a7 7 0 104.2 12.6.999.999 0 00.093.107l3 3a1 1 0 001.414-1.414l-3-3a.999.999 0 00-.107-.093A7 7 0 009 2z"
                fill-rule="evenodd"
                fill="#17202A"
              ></path>
            </svg>
          </button>
          <el-button type="danger" size="small" @click="clearRecycleBin" style="margin-left: 50px; color: var(--Tipping-hover-color)">
            清空回收站
          </el-button>
          <div v-if="result.length" class="search-results">
            <ul>
              <li v-for="item in result" :key="item.id">
                {{ item.title }}
              </li>
            </ul>
          </div>
          <div v-if="data.length && isShow" class="autocomplete-results">
            <ul>
              <li v-for="item in data" :key="item.id">
                {{ item.title }}
              </li>
            </ul>
          </div>
          <div v-if="result.length" class="search-results">
            <ul>
              <li v-for="item in result" :key="item.id">
                {{ item.title }}
              </li>
            </ul>
          </div>
          <div v-if="data.length && isShow" class="autocomplete-results">
            <ul>
              <li v-for="item in data" :key="item.id">
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
        <div>
          <div v-if="loading" class="loading">加载中...</div>
          <div v-else-if="error" class="error">{{ error }}</div>
          <div v-else-if="!recycleList.length" class="empty">回收站为空</div>
          <div v-else>
            <div v-for="(notepad, index) in recycleList" :key="notepad.id" class="notepad-item">
              <div class="notepad-content">
                <h3>{{ notepad.title }}</h3>
                <p>{{ notepad.content }}</p>
                <span>创建时间: {{ formatTime(notepad.time) }}</span>
                <span>删除时间: {{ formatTime(notepad.deleted_at) }}</span>
                <span v-if="notepad.is_encrypted" class="encrypted">已加密</span>
                <span>版本: {{ notepad.version }}</span>
              </div>
              <div class="action-layout">
                <el-button type="primary" size="small" @click.stop="restoreNotepad(notepad, index)">
                  <svg t="1746710518415" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12005" width="20" height="20">
                    <path d="M512 883.2A371.2 371.2 0 1 0 140.8 512 371.2 371.2 0 0 0 512 883.2z m0 64a435.2 435.2 0 1 1 435.2-435.2 435.2 435.2 0 0 1-435.2 435.2z" fill="#1296db" p-id="12006"></path>
                    <path d="M704 352H448a32 32 0 0 0-32 32v256a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32V384a32 32 0 0 0-32-32zm-32 256H480V416h192v192z" fill="#1296db" p-id="12007"></path>
                  </svg>
                  恢复
                </el-button>
                <el-button type="danger" size="small" @click.stop="permanentlyDeleteNotepad(notepad, index)">
                  <svg t="1746710518415" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12005" width="20" height="20">
                    <path d="M512 883.2A371.2 371.2 0 1 0 140.8 512 371.2 371.2 0 0 0 512 883.2z m0 64a435.2 435.2 0 1 1 435.2-435.2 435.2 435.2 0 0 1-435.2 435.2z" fill="#1296db" p-id="12006"></path>
                    <path d="M557.056 512l122.368 122.368a31.744 31.744 0 1 1-45.056 45.056L512 557.056l-122.368 122.368a31.744 31.744 0 1 1-45.056-45.056L466.944 512 344.576 389.632a31.744 31.744 0 1 1 45.056-45.056L512 466.944l122.368-122.368a31.744 31.744 0 1 1 45.056 45.056z" fill="#1296db" p-id="12007"></path>
                  </svg>
                  永久删除
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      recycleList: [],
      loading: false,
      error: null,
      keywords: '',
      result: [],
      data: [],
      isShow: false,
      isPageLoaded: false,
      searchHistory: []
    };
  },
  mounted() {
    this.isPageLoaded = true;
    const token = localStorage.getItem('token');
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    console.log('检查登录状态，Token:', token, 'isLoggedIn:', isLoggedIn);
    if (!token || !isLoggedIn) {
      console.log('未登录，跳转到登录页');
      this.$message.error('请先登录');
      this.$router.push('/login');
      return;
    }
    this.loadRecycleBin();
  },
  methods: {
    async loadRecycleBin() {
      this.loading = true;
      this.error = null;
      try {
        const token = localStorage.getItem('token');
        console.log('加载回收站列表，Token:', token);
        const response = await axios.get('https://a.410121.xyz/api/recycle', {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 5000
        });
        console.log('回收站列表响应:', response.data);
        if (response.data.code === 200) {
          this.recycleList = response.data.data;
        } else {
          throw new Error(response.data.message || '加载回收站失败');
        }
      } catch (error) {
        console.error('加载回收站错误:', error);
        let message = error.response?.data?.message || error.message || '网络错误，请检查服务器连接';
        if (error.code === 'ECONNABORTED') {
          message = '请求超时，请检查网络或服务器状态';
        } else if (error.response?.status === 401) {
          message = '认证失败，请重新登录';
          console.log('认证失败，跳转到登录页');
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('userId');
          localStorage.removeItem('username');
          localStorage.removeItem('token');
          this.$router.push('/login');
        }
        this.error = message;
        this.$message.error(`加载失败: ${message}`);
      } finally {
        this.loading = false;
      }
    },

    async restoreNotepad(notepad, index) {
      this.$confirm('确定要恢复此记事吗？', '提示', { type: 'info' })
        .then(async () => {
          try {
            const token = localStorage.getItem('token');
            if (!token) {
              throw new Error('用户未登录，请先登录');
            }
            const response = await axios.put(`https://a.410121.xyz/api/recycle/${notepad.id}`, {}, {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.code === 200) {
              this.recycleList.splice(index, 1);
              this.$message.success('恢复成功');
            } else {
              throw new Error(response.data.message || '恢复失败');
            }
          } catch (error) {
            let message = error.response?.data?.message || error.message || '网络错误';
            if (error.code === 'ECONNABORTED') {
              message = '请求超时，请检查网络或服务器状态';
            } else if (error.response?.status === 401) {
              message = '认证失败，请重新登录';
              console.log('认证失败，跳转到登录页');
              localStorage.removeItem('isLoggedIn');
              localStorage.removeItem('userId');
              localStorage.removeItem('username');
              localStorage.removeItem('token');
              this.$router.push('/login');
            }
            this.$message.error(`恢复失败: ${message}`);
          }
        })
        .catch(() => {});
    },

    async permanentlyDeleteNotepad(notepad, index) {
      this.$confirm('确定要永久删除此记事吗？此操作不可恢复！', '警告', { type: 'warning' })
        .then(async () => {
          try {
            const token = localStorage.getItem('token');
            if (!token) {
              throw new Error('用户未登录，请先登录');
            }
            const response = await axios.delete(`https://a.410121.xyz/api/recycle/${notepad.id}`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.code === 200) {
              this.recycleList.splice(index, 1);
              this.$message.success('永久删除成功');
            } else {
              throw new Error(response.data.message || '永久删除失败');
            }
          } catch (error) {
            let message = error.response?.data?.message || error.message || '网络错误';
            if (error.code === 'ECONNABORTED') {
              message = '请求超时，请检查网络或服务器状态';
            } else if (error.response?.status === 401) {
              message = '认证失败，请重新登录';
              console.log('认证失败，跳转到登录页');
              localStorage.removeItem('isLoggedIn');
              localStorage.removeItem('userId');
              localStorage.removeItem('username');
              localStorage.removeItem('token');
              this.$router.push('/login');
            }
            this.$message.error(`永久删除失败: ${message}`);
          }
        })
        .catch(() => {});
    },

    async search() {
      this.result = [];
      this.isShow = false;
      const token = localStorage.getItem('token');
      if (!token) {
        this.$message.error('用户未登录，请先登录');
        this.$router.push('/login');
        return;
      }
      try {
        const response = await axios.get('https://a.410121.xyz/api/recycle', {
          params: { keywords: this.keywords },
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log('搜索回收站响应:', response.data);
        if (response.data.code === 200) {
          this.result = response.data.data;
          if (!this.searchHistory.includes(this.keywords)) {
            this.searchHistory.push(this.keywords);
          }
        } else {
          throw new Error(response.data.message || '搜索失败');
        }
      } catch (error) {
        console.error('搜索请求失败:', error);
        let message = error.response?.data?.message || error.message || '搜索失败';
        if (error.response?.status === 401) {
          message = '认证失败，请重新登录';
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('userId');
          localStorage.removeItem('username');
          localStorage.removeItem('token');
          this.$router.push('/login');
        }
        this.$message.error(message);
      }
    },

    async getData(event) {
      if (!this.isPageLoaded) return;
      if (event.keyCode === 13) {
        this.isShow = false;
        return;
      }
      this.isShow = true;
      const token = localStorage.getItem('token');
      if (!token) {
        this.$message.error('用户未登录，请先登录');
        this.$router.push('/login');
        return;
      }
      try {
        const response = await axios.get('https://a.410121.xyz/api/recycle', {
          params: { keywords: this.keywords },
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log('实时搜索回收站响应:', response.data);
        if (response.data.code === 200) {
          this.data = response.data.data;
        } else {
          throw new Error(response.data.message || '实时搜索失败');
        }
      } catch (error) {
        console.error('实时搜索请求失败:', error);
        let message = error.response?.data?.message || error.message || '实时搜索失败';
        if (error.response?.status === 401) {
          message = '认证失败，请重新登录';
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('userId');
          localStorage.removeItem('username');
          localStorage.removeItem('token');
          this.$router.push('/login');
        }
        this.$message.error(message);
      }
    },

    clearRecycleBin() {
      this.$confirm('确定要清空回收站吗？此操作不可恢复！', '警告', { type: 'warning' })
        .then(async () => {
          try {
            this.loading = true;
            const token = localStorage.getItem('token');
            if (!token) {
              throw new Error('用户未登录，请先登录');
            }
            const response = await axios.delete('https://a.410121.xyz/api/recycle/clear', {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.code === 200) {
              this.recycleList = []; // 清空前端列表
              this.$message.success('回收站已清空');
            } else {
              throw new Error(response.data.message || '清空失败');
            }
          } catch (error) {
            let message = error.response?.data?.message || error.message || '网络错误';
            if (error.response?.status === 401) {
              message = '认证失败，请重新登录';
              localStorage.removeItem('isLoggedIn');
              localStorage.removeItem('userId');
              localStorage.removeItem('username');
              localStorage.removeItem('token');
              this.$router.push('/login');
            }
            this.$message.error(`清空失败: ${message}`);
          } finally {
            this.loading = false;
          }
        })
        .catch(() => {});
    },

    handleBlur() {
      setTimeout(() => {
        this.isShow = false;
      }, 100);
    },

    formatTime(time) {
      return new Date(time).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' });
    }
  }
};
</script>

<style scoped>
.w {
  width: 1700px;
  margin: 0 auto;
}
img {
  width: 100%;
  height: 100%;
  display: block;
}
#home {
  width: 100%;
}
#contentBox {
  width: 100%;
  height: 100%;
  position: relative;
  background-repeat: no-repeat;
  overflow: auto;
  z-index: 0;
}
.registervideoContainer {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: 0rem;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -1;
  background-image: url(../assets/2.jpg);
  filter: blur(6px);
}
.resource {
  margin-left: 38%;
  font-size: 35px;
  color: #054e61b4;
}
.notepad-item {
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
  margin-left: 6%;
  margin-top: 2%;
}
.notepad-content h3 {
  margin: 0;
}
.notepad-content p {
  margin: 5px 0;
}
.notepad-content span {
  font-size: 0.8em;
  color: #666;
  display: block;
}
.encrypted {
  color: #e67e22;
}
.action-layout {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}
.shousuo {
  margin-left: 6%;
  display: flex;
  align-items: center;
}
.shousuo input {
  width: 200px;
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #999cff;
  background-image: radial-gradient(at 85% 51%, hsl(313deg 20.99% 83.24%) 0px, transparent 110%),
    radial-gradient(at 74% 68%, hsla(235, 69%, 77%, 1) 0px, #00000000 50%),
    radial-gradient(at 64% 79%, hsl(284deg 25.64% 71.61% / 67%) 0px, transparent 30%),
    radial-gradient(at 75% 16%, hsla(283, 60%, 72%, 1) 0px, transparent 50%),
    radial-gradient(at 90% 65%, hsla(153, 70%, 64%, 1) 0px, transparent 50%),
    radial-gradient(at 91% 83%, hsla(283, 74%, 69%, 1) 0px, #00000000 50%),
    radial-gradient(at 72% 91%, hsl(210.98deg 93.99% 21.59% / 96%) 0px, transparent 50%);
}
.input__search {
  width: 100%;
  border-radius: 20px;
  outline: none;
  border: none;
  padding: 8px;
  position: relative;
}
.shousuo button {
  padding: 5px 12px;
  margin-left: -0.5%;
  font-size: 16px;
  color: var(--input-right-bottom-color);
  background-color: #4bd5db;
  border: none;
  border-radius: 9px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.shousuo button:hover {
  background-color: #00a7b38c;
}
.search-results,
.autocomplete-results {
  position: absolute;
  top: 5%;
  left: 11%;
  background: white;
  box-shadow: 0 0 10px rgba(51, 227, 240, 0.5);
  border: 1px solid #ccc;
  border-radius: 4px;
  border-top: none;
  z-index: 1000;
  width: 215px;
  max-height: 300px;
  overflow-y: auto;
}
.search-results ul,
.autocomplete-results ul {
  margin: 0;
  padding: 0;
}
.search-results li,
.autocomplete-results li {
  padding: 8px;
  cursor: pointer;
}
.search-results li:hover,
.autocomplete-results li:hover {
  background-color: #f0f0f0;
}
.loading, .error, .empty {
  text-align: center;
  margin-top: 20px;
  font-size: 18px;
}
@media screen and (max-width: 1600px) {
  .w {
    max-width: 1400px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
}
@media screen and (max-width: 1400px) {
  .w {
    max-width: 1200px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
  .shousuo {
    margin-top: 1%;
    margin-left: 15%;
  }
}
@media screen and (max-width: 1200px) {
  .w {
    max-width: 1000px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
}
@media screen and (max-width: 1000px) {
  .w {
    max-width: 100%;
  }
  .search-results,
  .autocomplete-results {
    top: 2.7%;
    left: 15%;
  }
}
@media screen and (max-width: 550px) {
  .w {
    max-width: 100%;
  }
  .shousuo {
    margin-top: 1%;
    margin-left: 4%;
  }
  .search-results,
  .autocomplete-results {
    top: 2.3%;
    left: 4%;
  }
}
</style>